import { Link, NavLink } from "react-router-dom";
import { useGetbrands } from "../../hooks/useProducts";
import { useState } from "react";
import { useClient } from "../../context/client-context";

const HeaderBrandsMain = ({
  handleMenuClick,
  activeIndex,
  setActiveIndex,
  isForMobile = false,
  isAuthenticated,
  user,
  handleLogOut,
}) => {
  const [pageData, setPageData] = useState({
    pageIndex: 0,
    pageSize: 20,
  });

  const {
    data = {},
    // isPending,
    isError: brandsIsError,
    error: brandsError,
  } = useGetbrands(pageData);

  let { data: brands = [] } = data?.brands ?? {};
  const client = useClient();

  let pageSize = data?.brands?.count ?? 0;

  const hasNextPage = () => {
    return pageData.pageIndex + 1 >= pageSize / pageData.pageSize;
  };

  if (brandsIsError)
    return (
      <>
        {isForMobile ? (
          <ul className="nav-menu flex-align nav-menu--mobile">
            <li className="on-hover-item nav-menu__item has-submenu">
              <Link to="#" className="nav-menu__link">
                Error getting brands {brandsError}
              </Link>
            </li>
            <li className="common-dropdown__item nav-submenu__item">
              <Link
                to="/auth/login"
                className="common-dropdown__link nav-submenu__link hover-bg-neutral-100"
                onClick={() => setActiveIndex(null)}
              >
                {" "}
                My Account
              </Link>
            </li>
            {isAuthenticated ? (
              <>
                <li
                  onClick={() => handleMenuClick(1)}
                  className={`on-hover-item nav-menu__item has-submenu ${
                    activeIndex === 1 ? "d-block" : ""
                  }`}
                >
                  <Link to="#" className="nav-menu__link">
                    <span className="text-2xl text-gray-700 item-hover__text">
                      <i className="ph ph-user-circle" />
                    </span>
                    {user?.userName || "My Account"}
                  </Link>
                  <ul
                    className={`on-hover-dropdown common-dropdown nav-submenu scroll-sm ${
                      activeIndex === 1 ? "open" : ""
                    }`}
                  >
                    <li className="common-dropdown__item nav-submenu__item">
                      <Link
                        to="/orders"
                        className="common-dropdown__link nav-submenu__link hover-bg-neutral-100"
                        onClick={() => setActiveIndex(null)}
                      >
                        {" "}
                        My Orders
                      </Link>
                    </li>
                    <li className="common-dropdown__item nav-submenu__item">
                      <Link
                        to="/customer/account"
                        className="common-dropdown__link nav-submenu__link hover-bg-neutral-100"
                        onClick={() => setActiveIndex(null)}
                      >
                        {" "}
                        My Profile
                      </Link>
                    </li>
                    <li
                      className="common-dropdown__item nav-submenu__item"
                      onClick={handleLogOut}
                      role="button"
                    >
                      <span className="common-dropdown__link nav-submenu__link hover-bg-danger-100">
                        Logout
                      </span>
                    </li>
                  </ul>
                </li>
                <li
                  // onClick={() => handleMenuClick(1)}
                  className={`on-hover-item nav-menu__item mt-5`}
                >
                  <Link
                    to="/products/prescription-products"
                    className="btn btn-sm bg-gray-600 py-8"
                  >
                    <i className="ph ph-file-arrow-up me-5"></i>
                    Prescriptions
                  </Link>
                </li>
              </>
            ) : (
              <li className="common-dropdown__item nav-submenu__item">
                <Link
                  to="/auth/login"
                  className="common-dropdown__link nav-submenu__link hover-bg-neutral-100"
                  onClick={() => setActiveIndex(null)}
                >
                  {" "}
                  My Account
                </Link>
              </li>
            )}
          </ul>
        ) : (
          <ul className="nav-menu flex-align ">
            <li className="on-hover-item nav-menu__item has-submenu">
              <Link to="#" className="nav-menu__link">
                Brands
              </Link>
              <div className="container-fluid on-hover-dropdown common-dropdown nav-submenu scroll-sm">
                Error getting brands {brandsError}
              </div>
            </li>
          </ul>
        )}
      </>
    );

  return (
    <>
      {isForMobile ? (
        <>
          <ul className="nav-menu flex-align nav-menu--mobile">
            {/* Brands */}
            <li
              onClick={() => handleMenuClick(0)}
              className={`on-hover-item nav-menu__item has-submenu ${
                activeIndex === 0 ? "d-block" : ""
              }`}
            >
              <Link to="#" className="nav-menu__link tex-sm">
                Brands
              </Link>
              <ul
                className={`on-hover-dropdown common-dropdown nav-submenu scroll-sm ${
                  activeIndex === 0 ? "open" : ""
                }`}
              >
                {brands.map((brand, index) => (
                  <li
                    className="common-dropdown__item nav-submenu__item"
                    key={index}
                  >
                    <Link
                      to={`/products/category?brand=${brand?.name}`}
                      className="common-dropdown__link nav-submenu__link hover-bg-neutral-100"
                      onClick={() => setActiveIndex(null)}
                    >
                      {brand?.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </li>

            {isAuthenticated ? (
              <>
                <li
                  onClick={() => handleMenuClick(1)}
                  className={`on-hover-item nav-menu__item has-submenu ${
                    activeIndex === 1 ? "d-block" : ""
                  }`}
                >
                  <Link to="#" className="nav-menu__link">
                    <span className="text-2xl text-gray-700 item-hover__text">
                      <i className="ph ph-user-circle" />
                    </span>
                    {user?.userName || "My Account"}
                  </Link>
                  <ul
                    className={`on-hover-dropdown common-dropdown nav-submenu scroll-sm ${
                      activeIndex === 1 ? "open" : ""
                    }`}
                  >
                    {/* <li className="common-dropdown__item nav-submenu__item">
                    <Link
                      to="/orders"
                      className="common-dropdown__link nav-submenu__link hover-bg-neutral-100"
                      onClick={() => setActiveIndex(null)}
                    >
                      My Orders
                    </Link>
                  </li> */}
                    <li className="common-dropdown__item nav-submenu__item">
                      <Link
                        to="/profile"
                        className="common-dropdown__link nav-submenu__link hover-bg-neutral-100"
                        onClick={() => setActiveIndex(null)}
                      >
                        {" "}
                        My Profile
                      </Link>
                    </li>
                    <li
                      className="common-dropdown__item nav-submenu__item"
                      onClick={handleLogOut}
                      role="button"
                    >
                      <span className="common-dropdown__link nav-submenu__link hover-bg-danger-100">
                        Logout
                      </span>
                    </li>
                  </ul>
                </li>
                <li
                  // onClick={() => handleMenuClick(1)}
                  className={`on-hover-item nav-menu__item mt-5`}
                >
                  <Link
                    to="/products/prescription-products"
                    className="btn btn-sm bg-gray-600 py-8"
                  >
                    <i className="ph ph-file-arrow-up me-5"></i>
                    Prescriptions
                  </Link>
                </li>
                <a
                  href="tel:+254702585388"
                  className="bg-main-600 text-white p-12 h-100 hover-bg-main-800 flex-align gap-8 text-lg d-lg-flex d-none"
                >
                  <div className="d-flex text-32">
                    <i className="ph ph-phone-call" />
                  </div>
                  {client.contact}
                </a>
              </>
            ) : (
              <>
                <li className="common-dropdown__item nav-submenu__item">
                  <Link
                    to="/auth/login"
                    className="common-dropdown__link nav-submenu__link hover-bg-neutral-100"
                    onClick={() => setActiveIndex(null)}
                  >
                    My Account
                  </Link>
                </li>
              </>
            )}
          </ul>
          <a
            href="tel:+254702585388"
            className="bg-main-600 text-white p-12 h-100 hover-bg-main-800 flex-align gap-8 text-lg d-lg-flex"
          >
            <div className="d-flex text-32">
              <i className="ph ph-phone-call" />
            </div>
            {client.contact}
          </a>
        </>
      ) : (
        <ul className="nav-menu flex-align ">
          <li className="on-hover-item nav-menu__item has-submenu">
            <Link to="#" className="nav-menu__link text-sm">
              Brands
            </Link>
            <div className="container-fluid on-hover-dropdown common-dropdown nav-submenu scroll-sm">
              <p className="fw-bold fs-6 text-dark">Brands</p>
              <p className="text-xs">
                Explore our {brands?.length || 0} brands of product
              </p>
              <div className="row gap-5 mt-5 px-10">
                {brands.map((brand, index) => (
                  <div
                    className="col-md-3 common-dropdown__item nav-submenu__item shadow p-10 text-center hover-bg-main-50 hover-text-main-600"
                    key={index}
                  >
                    <Link to={`/products/category?brand=${brand.name}`}>
                      <img
                        src={"/assets/images/thumbs/brand-img7.png"}
                        // src={brand?.brandImageUrl}
                        className="img-fluid"
                        width={200}
                        alt=""
                      />
                      <p className="text-dark text-xs">{brand?.name}</p>
                    </Link>
                  </div>
                ))}
              </div>
              <hr />
              <div className="d-flex justify-content-start">
                <div>
                  <button
                    className="btn btn-sm page-link h-20 w-44 flex-center text-xxl rounded-8 fw-medium text-neutral-600 border border-gray-100"
                    disabled={pageData.pageIndex === 0}
                    onClick={() =>
                      setPageData((prevData) => ({
                        ...prevData,
                        pageIndex: prevData.pageIndex - 1,
                      }))
                    }
                  >
                    <i className="ph-bold ph-arrow-left" />
                  </button>
                  {!hasNextPage() && (
                    <button
                      className="btn btn-sm page-link h-20 w-44 flex-center text-xxl rounded-8 fw-medium text-neutral-600 border border-gray-100"
                      disabled={hasNextPage()}
                      onClick={() =>
                        setPageData((prevData) => ({
                          ...prevData,
                          pageIndex: prevData.pageIndex + 1,
                        }))
                      }
                    >
                      <i className="ph-bold ph-arrow-right" />
                    </button>
                  )}
                </div>
              </div>
            </div>
            {/* <ul className="on-hover-dropdown common-dropdown nav-submenu scroll-sm">
            <li className="common-dropdown__item nav-submenu__item">
              <NavLink
                to="/"
                className={(navData) =>
                  navData.isActive
                    ? "common-dropdown__link nav-submenu__link hover-bg-neutral-100 activePage"
                    : "common-dropdown__link nav-submenu__link hover-bg-neutral-100"
                }
              >
                Home Grocery
              </NavLink>
            </li>
            <li className="common-dropdown__item nav-submenu__item">
              <NavLink
                to="/index-two"
                className={(navData) =>
                  navData.isActive
                    ? "common-dropdown__link nav-submenu__link hover-bg-neutral-100 activePage"
                    : "common-dropdown__link nav-submenu__link hover-bg-neutral-100"
                }
              >
                {" "}
                Home Electronics
              </NavLink>
            </li>
            <li className="common-dropdown__item nav-submenu__item">
              <NavLink
                to="/index-three"
                className={(navData) =>
                  navData.isActive
                    ? "common-dropdown__link nav-submenu__link hover-bg-neutral-100 activePage"
                    : "common-dropdown__link nav-submenu__link hover-bg-neutral-100"
                }
              >
                Home Fashion
              </NavLink>
            </li>
          </ul> */}
          </li>
        </ul>
      )}
    </>
  );
};

export default HeaderBrandsMain;
